import React, { useEffect } from "react";
import { View } from "react-native";

import Modal from "component/picker/Modal";

import Text from "component/typography/Text";
import Button from "component/button/Button";
import TextArea from "component/input/TextArea";
import { useForm, Controller } from "react-hook-form";

import { colors, sizes, strings } from "asset/constant";
import { css } from "style";
import { mq, sn } from "utils";

interface CartItemDescriptionT {
  visible: boolean;
  hide: () => void;
  description?: string;
  onConfirm?: (desc?: string) => void;
}

export default function CartItemDescription(props: CartItemDescriptionT) {
  const { visible, hide, description, onConfirm } = props;

  const {
    control,
    formState: { errors },
    getValues,
    setValue,
    handleSubmit,
  } = useForm({
    defaultValues: { description },
  });

  useEffect(() => {
    setValue("description", description);
  }, [description, setValue]);

  const _onSubmit = () => {
    hide();
    onConfirm && onConfirm(getValues().description);
  };

  return (
    <Modal visible={visible} close={hide}>
      <View
        style={{
          ...css.container,
          ...css.justifyFEnd,
        }}
      >
        <View
          style={{
            paddingVertical: mq(5),
            paddingHorizontal: mq(15),
            backgroundColor: colors.white,
            borderTopLeftRadius: sizes.radius.lg,
            borderTopRightRadius: sizes.radius.lg,
          }}
        >
          <Text style={{ marginVertical: mq(10) }} weight="extraBold">
            {strings.add_custom_attrs_descriptions}
          </Text>
          <Controller
            name="description"
            control={control}
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { value, onChange } }) => (
              <TextArea
                autoFocus
                value={value}
                onChangeText={onChange}
                icon={{ type: "materialCommunity", name: "format-align-right" }}
                placeholder={strings.insert_description}
                onSubmitEditing={handleSubmit(_onSubmit)}
                error={errors.description?.message}
              />
            )}
          />
        </View>
      </View>
      <View
        style={{
          ...css.fitWidth,
          maxWidth: sn("100%", "100%", 350, 350),
          ...css.height(70),
          ...css.justifySEvenly,
          ...css.rRowCenterAlign,
          ...css.bgColor(colors.white),
        }}
      >
        <Button
          onPress={hide}
          width={"46%"}
          bgColor={colors.white}
          bordered={{ width: 1, color: colors.theme }}
          title={{ value: strings.cancel, color: colors.theme }}
        />

        <Button
          onPress={handleSubmit(_onSubmit)}
          width={"46%"}
          title={{ value: strings.confirm }}
        />
      </View>
    </Modal>
  );
}
